'use strict';
var readingTime = require('reading-time');


export default class DetailHeader {
  constructor() {

    if ($('.text-block-body').length){
      let text = $('.text-block-body').text();
      let stats = readingTime(text);
      let readTime = Math.round(stats.time/ 60000);
      let readTimeText = readTime + " minute read"
      $('.detail-header-readtime p').text(readTimeText);
      $('.detail-header-readtime').css('opacity','1');
    }



  }
}
